import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupsExecuteSearchActions" */ './lazyIndex'),
    { name: 'GroupsExecuteSearchActions' }
);

export const lazyExecuteGroupSearch: LazyAction<
    typeof lazyIndex.executeGroupSearch,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.executeGroupSearch);
export const lazyloadMoreGroupSubstrateSearch: LazyAction<
    typeof lazyIndex.loadMoreGroupSubstrateSearch,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadMoreGroupSubstrateSearch);
